import React from "react";

import Bradcom from "./Utils/Bradcom";
import Most from "./Utils/Most";
import HistoricalPhotos from './Utils/HistoricalPhotos';

export default function Main() {
  return (
    <>
      <main>
        <Bradcom />
        <Most>
          <div
            className="about-content s-about-content  wow fadeInRight  animated"
            data-animation="fadeInRight"
            data-delay="3s"
            style={{textAlign: "justify"}}
          >
            <div className="about-title second-title pb-4">
              <h1 className="display-2">Słoneczne Podgórze</h1>
            </div>
            <p className="text-justify">
              Pensjonat znajduje się około 2 km od Parku Zdrojowego, przy końcu
              utwardzonej drogi. Teren ośrodka to niemal 2 hektary obejmujące
              obszar leśny i łąki, teren rekreacyjny. W najbliższym otoczeniu
              przebiega &nbsp;
              <a
                href="https://pl.wikipedia.org/wiki/G%C5%82%C3%B3wny_Szlak_Sudecki"
                target="_blank"
                style={{ textDecoration: "underline", color: "#0d6efd" }}
              >
                Główny Szlak Sudecki
              </a>
              . W linii prostej to tylko 1,2 km do Czech.
            </p>
            <p className="text-justify">
              Mamy 60 miejsc w 16 pokojach (2, 3, 4, i 5 osobowych z
              łazienkami), z dostępem do Internetu Wi – fi (światłowód). Pokoje
              znajdują się w 2 budynkach. W pierwszym budynku są jadalnia, duża
              sala rekreacyjna z przepięknym widokiem na górę Graniczną,
              biblioteczka oraz kącik gier, cztery pokoje. W drugim dwanaście
              pokoi oraz w ofercie proponujemy Państwu pobyt z wyżywieniem.
            </p>
            <p className="text-justify">
              Słoneczne Podgórze to miejsce stworzone dla grup. Zapraszamy:
              wycieczki szkolne, obozy sportowe, kolonie letnie, zorganizowane
              grupy na warsztaty, uniwersytety trzeciego wieku. W ferie,
              wakacje, weekendy zapraszamy gości indywidualnych.
            </p>
          </div>
        </Most>
        <HistoricalPhotos/>
      </main>
    </>
  );
};